/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminPerformanceRouteImport } from './routes/admin/performance'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminSupportIndexRouteImport } from './routes/admin/support/index'
import { Route as AdminPlansIndexRouteImport } from './routes/admin/plans/index'
import { Route as AdminJobsIndexRouteImport } from './routes/admin/jobs/index'
import { Route as AdminEmployeesIndexRouteImport } from './routes/admin/employees/index'
import { Route as AdminCustomersIndexRouteImport } from './routes/admin/customers/index'
import { Route as AdminSupportTicketIdRouteImport } from './routes/admin/support/$ticketId'
import { Route as AdminScoutTargetsRouteImport } from './routes/admin/scout/targets'
import { Route as AdminScoutRunsRouteImport } from './routes/admin/scout/runs'
import { Route as AdminScoutProgramsRouteImport } from './routes/admin/scout/programs'
import { Route as AdminScoutPostingsRouteImport } from './routes/admin/scout/postings'
import { Route as AdminJobsScrapingQueueRouteImport } from './routes/admin/jobs/scraping-queue'
import { Route as AdminJobsNewRouteImport } from './routes/admin/jobs/new'
import { Route as AdminJobsDuplicatesRouteImport } from './routes/admin/jobs/duplicates'
import { Route as AdminJobsBulkUploadRouteImport } from './routes/admin/jobs/bulk-upload'
import { Route as AdminJobsIdRouteImport } from './routes/admin/jobs/$id'
import { Route as AdminEmployeesIdRouteImport } from './routes/admin/employees/$id'
import { Route as AdminCustomersRecommendationsRouteImport } from './routes/admin/customers/recommendations'
import { Route as AdminCustomersNewRouteImport } from './routes/admin/customers/new'
import { Route as AdminCustomersIdRouteImport } from './routes/admin/customers/$id'
import { Route as AdminJobsIdIndexRouteImport } from './routes/admin/jobs/$id/index'
import { Route as AdminEmployeesIdIndexRouteImport } from './routes/admin/employees/$id/index'
import { Route as AdminJobsIdScrapingRouteImport } from './routes/admin/jobs/$id/scraping'
import { Route as AdminJobsIdQualityRouteImport } from './routes/admin/jobs/$id/quality'
import { Route as AdminJobsIdEditRouteImport } from './routes/admin/jobs/$id/edit'
import { Route as AdminJobsIdDuplicatesRouteImport } from './routes/admin/jobs/$id/duplicates'
import { Route as AdminJobsIdDetailsRouteImport } from './routes/admin/jobs/$id/details'
import { Route as AdminJobsIdCandidatesRouteImport } from './routes/admin/jobs/$id/candidates'
import { Route as AdminJobsIdAssignedCustomersRouteImport } from './routes/admin/jobs/$id/assigned-customers'
import { Route as AdminEmployeesIdJobsRouteImport } from './routes/admin/employees/$id/jobs'
import { Route as AdminEmployeesIdGoalsRouteImport } from './routes/admin/employees/$id/goals'
import { Route as AdminEmployeesIdFeedbackRouteImport } from './routes/admin/employees/$id/feedback'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPerformanceRoute = AdminPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSupportIndexRoute = AdminSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlansIndexRoute = AdminPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsIndexRoute = AdminJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmployeesIndexRoute = AdminEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersIndexRoute = AdminCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSupportTicketIdRoute = AdminSupportTicketIdRouteImport.update({
  id: '/support/$ticketId',
  path: '/support/$ticketId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminScoutTargetsRoute = AdminScoutTargetsRouteImport.update({
  id: '/scout/targets',
  path: '/scout/targets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminScoutRunsRoute = AdminScoutRunsRouteImport.update({
  id: '/scout/runs',
  path: '/scout/runs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminScoutProgramsRoute = AdminScoutProgramsRouteImport.update({
  id: '/scout/programs',
  path: '/scout/programs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminScoutPostingsRoute = AdminScoutPostingsRouteImport.update({
  id: '/scout/postings',
  path: '/scout/postings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsScrapingQueueRoute = AdminJobsScrapingQueueRouteImport.update({
  id: '/jobs/scraping-queue',
  path: '/jobs/scraping-queue',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsNewRoute = AdminJobsNewRouteImport.update({
  id: '/jobs/new',
  path: '/jobs/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsDuplicatesRoute = AdminJobsDuplicatesRouteImport.update({
  id: '/jobs/duplicates',
  path: '/jobs/duplicates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsBulkUploadRoute = AdminJobsBulkUploadRouteImport.update({
  id: '/jobs/bulk-upload',
  path: '/jobs/bulk-upload',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsIdRoute = AdminJobsIdRouteImport.update({
  id: '/jobs/$id',
  path: '/jobs/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmployeesIdRoute = AdminEmployeesIdRouteImport.update({
  id: '/employees/$id',
  path: '/employees/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersRecommendationsRoute =
  AdminCustomersRecommendationsRouteImport.update({
    id: '/customers/recommendations',
    path: '/customers/recommendations',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCustomersNewRoute = AdminCustomersNewRouteImport.update({
  id: '/customers/new',
  path: '/customers/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersIdRoute = AdminCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsIdIndexRoute = AdminJobsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminJobsIdRoute,
} as any)
const AdminEmployeesIdIndexRoute = AdminEmployeesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminEmployeesIdRoute,
} as any)
const AdminJobsIdScrapingRoute = AdminJobsIdScrapingRouteImport.update({
  id: '/scraping',
  path: '/scraping',
  getParentRoute: () => AdminJobsIdRoute,
} as any)
const AdminJobsIdQualityRoute = AdminJobsIdQualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => AdminJobsIdRoute,
} as any)
const AdminJobsIdEditRoute = AdminJobsIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AdminJobsIdRoute,
} as any)
const AdminJobsIdDuplicatesRoute = AdminJobsIdDuplicatesRouteImport.update({
  id: '/duplicates',
  path: '/duplicates',
  getParentRoute: () => AdminJobsIdRoute,
} as any)
const AdminJobsIdDetailsRoute = AdminJobsIdDetailsRouteImport.update({
  id: '/details',
  path: '/details',
  getParentRoute: () => AdminJobsIdRoute,
} as any)
const AdminJobsIdCandidatesRoute = AdminJobsIdCandidatesRouteImport.update({
  id: '/candidates',
  path: '/candidates',
  getParentRoute: () => AdminJobsIdRoute,
} as any)
const AdminJobsIdAssignedCustomersRoute =
  AdminJobsIdAssignedCustomersRouteImport.update({
    id: '/assigned-customers',
    path: '/assigned-customers',
    getParentRoute: () => AdminJobsIdRoute,
  } as any)
const AdminEmployeesIdJobsRoute = AdminEmployeesIdJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminEmployeesIdRoute,
} as any)
const AdminEmployeesIdGoalsRoute = AdminEmployeesIdGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => AdminEmployeesIdRoute,
} as any)
const AdminEmployeesIdFeedbackRoute =
  AdminEmployeesIdFeedbackRouteImport.update({
    id: '/feedback',
    path: '/feedback',
    getParentRoute: () => AdminEmployeesIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/performance': typeof AdminPerformanceRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/customers/$id': typeof AdminCustomersIdRoute
  '/admin/customers/new': typeof AdminCustomersNewRoute
  '/admin/customers/recommendations': typeof AdminCustomersRecommendationsRoute
  '/admin/employees/$id': typeof AdminEmployeesIdRouteWithChildren
  '/admin/jobs/$id': typeof AdminJobsIdRouteWithChildren
  '/admin/jobs/bulk-upload': typeof AdminJobsBulkUploadRoute
  '/admin/jobs/duplicates': typeof AdminJobsDuplicatesRoute
  '/admin/jobs/new': typeof AdminJobsNewRoute
  '/admin/jobs/scraping-queue': typeof AdminJobsScrapingQueueRoute
  '/admin/scout/postings': typeof AdminScoutPostingsRoute
  '/admin/scout/programs': typeof AdminScoutProgramsRoute
  '/admin/scout/runs': typeof AdminScoutRunsRoute
  '/admin/scout/targets': typeof AdminScoutTargetsRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/customers': typeof AdminCustomersIndexRoute
  '/admin/employees': typeof AdminEmployeesIndexRoute
  '/admin/jobs': typeof AdminJobsIndexRoute
  '/admin/plans': typeof AdminPlansIndexRoute
  '/admin/support': typeof AdminSupportIndexRoute
  '/admin/employees/$id/feedback': typeof AdminEmployeesIdFeedbackRoute
  '/admin/employees/$id/goals': typeof AdminEmployeesIdGoalsRoute
  '/admin/employees/$id/jobs': typeof AdminEmployeesIdJobsRoute
  '/admin/jobs/$id/assigned-customers': typeof AdminJobsIdAssignedCustomersRoute
  '/admin/jobs/$id/candidates': typeof AdminJobsIdCandidatesRoute
  '/admin/jobs/$id/details': typeof AdminJobsIdDetailsRoute
  '/admin/jobs/$id/duplicates': typeof AdminJobsIdDuplicatesRoute
  '/admin/jobs/$id/edit': typeof AdminJobsIdEditRoute
  '/admin/jobs/$id/quality': typeof AdminJobsIdQualityRoute
  '/admin/jobs/$id/scraping': typeof AdminJobsIdScrapingRoute
  '/admin/employees/$id/': typeof AdminEmployeesIdIndexRoute
  '/admin/jobs/$id/': typeof AdminJobsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/performance': typeof AdminPerformanceRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/customers/$id': typeof AdminCustomersIdRoute
  '/admin/customers/new': typeof AdminCustomersNewRoute
  '/admin/customers/recommendations': typeof AdminCustomersRecommendationsRoute
  '/admin/jobs/bulk-upload': typeof AdminJobsBulkUploadRoute
  '/admin/jobs/duplicates': typeof AdminJobsDuplicatesRoute
  '/admin/jobs/new': typeof AdminJobsNewRoute
  '/admin/jobs/scraping-queue': typeof AdminJobsScrapingQueueRoute
  '/admin/scout/postings': typeof AdminScoutPostingsRoute
  '/admin/scout/programs': typeof AdminScoutProgramsRoute
  '/admin/scout/runs': typeof AdminScoutRunsRoute
  '/admin/scout/targets': typeof AdminScoutTargetsRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/customers': typeof AdminCustomersIndexRoute
  '/admin/employees': typeof AdminEmployeesIndexRoute
  '/admin/jobs': typeof AdminJobsIndexRoute
  '/admin/plans': typeof AdminPlansIndexRoute
  '/admin/support': typeof AdminSupportIndexRoute
  '/admin/employees/$id/feedback': typeof AdminEmployeesIdFeedbackRoute
  '/admin/employees/$id/goals': typeof AdminEmployeesIdGoalsRoute
  '/admin/employees/$id/jobs': typeof AdminEmployeesIdJobsRoute
  '/admin/jobs/$id/assigned-customers': typeof AdminJobsIdAssignedCustomersRoute
  '/admin/jobs/$id/candidates': typeof AdminJobsIdCandidatesRoute
  '/admin/jobs/$id/details': typeof AdminJobsIdDetailsRoute
  '/admin/jobs/$id/duplicates': typeof AdminJobsIdDuplicatesRoute
  '/admin/jobs/$id/edit': typeof AdminJobsIdEditRoute
  '/admin/jobs/$id/quality': typeof AdminJobsIdQualityRoute
  '/admin/jobs/$id/scraping': typeof AdminJobsIdScrapingRoute
  '/admin/employees/$id': typeof AdminEmployeesIdIndexRoute
  '/admin/jobs/$id': typeof AdminJobsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/performance': typeof AdminPerformanceRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/customers/$id': typeof AdminCustomersIdRoute
  '/admin/customers/new': typeof AdminCustomersNewRoute
  '/admin/customers/recommendations': typeof AdminCustomersRecommendationsRoute
  '/admin/employees/$id': typeof AdminEmployeesIdRouteWithChildren
  '/admin/jobs/$id': typeof AdminJobsIdRouteWithChildren
  '/admin/jobs/bulk-upload': typeof AdminJobsBulkUploadRoute
  '/admin/jobs/duplicates': typeof AdminJobsDuplicatesRoute
  '/admin/jobs/new': typeof AdminJobsNewRoute
  '/admin/jobs/scraping-queue': typeof AdminJobsScrapingQueueRoute
  '/admin/scout/postings': typeof AdminScoutPostingsRoute
  '/admin/scout/programs': typeof AdminScoutProgramsRoute
  '/admin/scout/runs': typeof AdminScoutRunsRoute
  '/admin/scout/targets': typeof AdminScoutTargetsRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/customers/': typeof AdminCustomersIndexRoute
  '/admin/employees/': typeof AdminEmployeesIndexRoute
  '/admin/jobs/': typeof AdminJobsIndexRoute
  '/admin/plans/': typeof AdminPlansIndexRoute
  '/admin/support/': typeof AdminSupportIndexRoute
  '/admin/employees/$id/feedback': typeof AdminEmployeesIdFeedbackRoute
  '/admin/employees/$id/goals': typeof AdminEmployeesIdGoalsRoute
  '/admin/employees/$id/jobs': typeof AdminEmployeesIdJobsRoute
  '/admin/jobs/$id/assigned-customers': typeof AdminJobsIdAssignedCustomersRoute
  '/admin/jobs/$id/candidates': typeof AdminJobsIdCandidatesRoute
  '/admin/jobs/$id/details': typeof AdminJobsIdDetailsRoute
  '/admin/jobs/$id/duplicates': typeof AdminJobsIdDuplicatesRoute
  '/admin/jobs/$id/edit': typeof AdminJobsIdEditRoute
  '/admin/jobs/$id/quality': typeof AdminJobsIdQualityRoute
  '/admin/jobs/$id/scraping': typeof AdminJobsIdScrapingRoute
  '/admin/employees/$id/': typeof AdminEmployeesIdIndexRoute
  '/admin/jobs/$id/': typeof AdminJobsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/admin/analytics'
    | '/admin/dashboard'
    | '/admin/performance'
    | '/admin/settings'
    | '/admin/customers/$id'
    | '/admin/customers/new'
    | '/admin/customers/recommendations'
    | '/admin/employees/$id'
    | '/admin/jobs/$id'
    | '/admin/jobs/bulk-upload'
    | '/admin/jobs/duplicates'
    | '/admin/jobs/new'
    | '/admin/jobs/scraping-queue'
    | '/admin/scout/postings'
    | '/admin/scout/programs'
    | '/admin/scout/runs'
    | '/admin/scout/targets'
    | '/admin/support/$ticketId'
    | '/admin/customers'
    | '/admin/employees'
    | '/admin/jobs'
    | '/admin/plans'
    | '/admin/support'
    | '/admin/employees/$id/feedback'
    | '/admin/employees/$id/goals'
    | '/admin/employees/$id/jobs'
    | '/admin/jobs/$id/assigned-customers'
    | '/admin/jobs/$id/candidates'
    | '/admin/jobs/$id/details'
    | '/admin/jobs/$id/duplicates'
    | '/admin/jobs/$id/edit'
    | '/admin/jobs/$id/quality'
    | '/admin/jobs/$id/scraping'
    | '/admin/employees/$id/'
    | '/admin/jobs/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/admin/analytics'
    | '/admin/dashboard'
    | '/admin/performance'
    | '/admin/settings'
    | '/admin/customers/$id'
    | '/admin/customers/new'
    | '/admin/customers/recommendations'
    | '/admin/jobs/bulk-upload'
    | '/admin/jobs/duplicates'
    | '/admin/jobs/new'
    | '/admin/jobs/scraping-queue'
    | '/admin/scout/postings'
    | '/admin/scout/programs'
    | '/admin/scout/runs'
    | '/admin/scout/targets'
    | '/admin/support/$ticketId'
    | '/admin/customers'
    | '/admin/employees'
    | '/admin/jobs'
    | '/admin/plans'
    | '/admin/support'
    | '/admin/employees/$id/feedback'
    | '/admin/employees/$id/goals'
    | '/admin/employees/$id/jobs'
    | '/admin/jobs/$id/assigned-customers'
    | '/admin/jobs/$id/candidates'
    | '/admin/jobs/$id/details'
    | '/admin/jobs/$id/duplicates'
    | '/admin/jobs/$id/edit'
    | '/admin/jobs/$id/quality'
    | '/admin/jobs/$id/scraping'
    | '/admin/employees/$id'
    | '/admin/jobs/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/admin/analytics'
    | '/admin/dashboard'
    | '/admin/performance'
    | '/admin/settings'
    | '/admin/customers/$id'
    | '/admin/customers/new'
    | '/admin/customers/recommendations'
    | '/admin/employees/$id'
    | '/admin/jobs/$id'
    | '/admin/jobs/bulk-upload'
    | '/admin/jobs/duplicates'
    | '/admin/jobs/new'
    | '/admin/jobs/scraping-queue'
    | '/admin/scout/postings'
    | '/admin/scout/programs'
    | '/admin/scout/runs'
    | '/admin/scout/targets'
    | '/admin/support/$ticketId'
    | '/admin/customers/'
    | '/admin/employees/'
    | '/admin/jobs/'
    | '/admin/plans/'
    | '/admin/support/'
    | '/admin/employees/$id/feedback'
    | '/admin/employees/$id/goals'
    | '/admin/employees/$id/jobs'
    | '/admin/jobs/$id/assigned-customers'
    | '/admin/jobs/$id/candidates'
    | '/admin/jobs/$id/details'
    | '/admin/jobs/$id/duplicates'
    | '/admin/jobs/$id/edit'
    | '/admin/jobs/$id/quality'
    | '/admin/jobs/$id/scraping'
    | '/admin/employees/$id/'
    | '/admin/jobs/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/performance': {
      id: '/admin/performance'
      path: '/performance'
      fullPath: '/admin/performance'
      preLoaderRoute: typeof AdminPerformanceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/support/': {
      id: '/admin/support/'
      path: '/support'
      fullPath: '/admin/support'
      preLoaderRoute: typeof AdminSupportIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/plans/': {
      id: '/admin/plans/'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AdminPlansIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs/': {
      id: '/admin/jobs/'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AdminJobsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/employees/': {
      id: '/admin/employees/'
      path: '/employees'
      fullPath: '/admin/employees'
      preLoaderRoute: typeof AdminEmployeesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers/': {
      id: '/admin/customers/'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/support/$ticketId': {
      id: '/admin/support/$ticketId'
      path: '/support/$ticketId'
      fullPath: '/admin/support/$ticketId'
      preLoaderRoute: typeof AdminSupportTicketIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/scout/targets': {
      id: '/admin/scout/targets'
      path: '/scout/targets'
      fullPath: '/admin/scout/targets'
      preLoaderRoute: typeof AdminScoutTargetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/scout/runs': {
      id: '/admin/scout/runs'
      path: '/scout/runs'
      fullPath: '/admin/scout/runs'
      preLoaderRoute: typeof AdminScoutRunsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/scout/programs': {
      id: '/admin/scout/programs'
      path: '/scout/programs'
      fullPath: '/admin/scout/programs'
      preLoaderRoute: typeof AdminScoutProgramsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/scout/postings': {
      id: '/admin/scout/postings'
      path: '/scout/postings'
      fullPath: '/admin/scout/postings'
      preLoaderRoute: typeof AdminScoutPostingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs/scraping-queue': {
      id: '/admin/jobs/scraping-queue'
      path: '/jobs/scraping-queue'
      fullPath: '/admin/jobs/scraping-queue'
      preLoaderRoute: typeof AdminJobsScrapingQueueRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs/new': {
      id: '/admin/jobs/new'
      path: '/jobs/new'
      fullPath: '/admin/jobs/new'
      preLoaderRoute: typeof AdminJobsNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs/duplicates': {
      id: '/admin/jobs/duplicates'
      path: '/jobs/duplicates'
      fullPath: '/admin/jobs/duplicates'
      preLoaderRoute: typeof AdminJobsDuplicatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs/bulk-upload': {
      id: '/admin/jobs/bulk-upload'
      path: '/jobs/bulk-upload'
      fullPath: '/admin/jobs/bulk-upload'
      preLoaderRoute: typeof AdminJobsBulkUploadRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs/$id': {
      id: '/admin/jobs/$id'
      path: '/jobs/$id'
      fullPath: '/admin/jobs/$id'
      preLoaderRoute: typeof AdminJobsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/employees/$id': {
      id: '/admin/employees/$id'
      path: '/employees/$id'
      fullPath: '/admin/employees/$id'
      preLoaderRoute: typeof AdminEmployeesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers/recommendations': {
      id: '/admin/customers/recommendations'
      path: '/customers/recommendations'
      fullPath: '/admin/customers/recommendations'
      preLoaderRoute: typeof AdminCustomersRecommendationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers/new': {
      id: '/admin/customers/new'
      path: '/customers/new'
      fullPath: '/admin/customers/new'
      preLoaderRoute: typeof AdminCustomersNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers/$id': {
      id: '/admin/customers/$id'
      path: '/customers/$id'
      fullPath: '/admin/customers/$id'
      preLoaderRoute: typeof AdminCustomersIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs/$id/': {
      id: '/admin/jobs/$id/'
      path: '/'
      fullPath: '/admin/jobs/$id/'
      preLoaderRoute: typeof AdminJobsIdIndexRouteImport
      parentRoute: typeof AdminJobsIdRoute
    }
    '/admin/employees/$id/': {
      id: '/admin/employees/$id/'
      path: '/'
      fullPath: '/admin/employees/$id/'
      preLoaderRoute: typeof AdminEmployeesIdIndexRouteImport
      parentRoute: typeof AdminEmployeesIdRoute
    }
    '/admin/jobs/$id/scraping': {
      id: '/admin/jobs/$id/scraping'
      path: '/scraping'
      fullPath: '/admin/jobs/$id/scraping'
      preLoaderRoute: typeof AdminJobsIdScrapingRouteImport
      parentRoute: typeof AdminJobsIdRoute
    }
    '/admin/jobs/$id/quality': {
      id: '/admin/jobs/$id/quality'
      path: '/quality'
      fullPath: '/admin/jobs/$id/quality'
      preLoaderRoute: typeof AdminJobsIdQualityRouteImport
      parentRoute: typeof AdminJobsIdRoute
    }
    '/admin/jobs/$id/edit': {
      id: '/admin/jobs/$id/edit'
      path: '/edit'
      fullPath: '/admin/jobs/$id/edit'
      preLoaderRoute: typeof AdminJobsIdEditRouteImport
      parentRoute: typeof AdminJobsIdRoute
    }
    '/admin/jobs/$id/duplicates': {
      id: '/admin/jobs/$id/duplicates'
      path: '/duplicates'
      fullPath: '/admin/jobs/$id/duplicates'
      preLoaderRoute: typeof AdminJobsIdDuplicatesRouteImport
      parentRoute: typeof AdminJobsIdRoute
    }
    '/admin/jobs/$id/details': {
      id: '/admin/jobs/$id/details'
      path: '/details'
      fullPath: '/admin/jobs/$id/details'
      preLoaderRoute: typeof AdminJobsIdDetailsRouteImport
      parentRoute: typeof AdminJobsIdRoute
    }
    '/admin/jobs/$id/candidates': {
      id: '/admin/jobs/$id/candidates'
      path: '/candidates'
      fullPath: '/admin/jobs/$id/candidates'
      preLoaderRoute: typeof AdminJobsIdCandidatesRouteImport
      parentRoute: typeof AdminJobsIdRoute
    }
    '/admin/jobs/$id/assigned-customers': {
      id: '/admin/jobs/$id/assigned-customers'
      path: '/assigned-customers'
      fullPath: '/admin/jobs/$id/assigned-customers'
      preLoaderRoute: typeof AdminJobsIdAssignedCustomersRouteImport
      parentRoute: typeof AdminJobsIdRoute
    }
    '/admin/employees/$id/jobs': {
      id: '/admin/employees/$id/jobs'
      path: '/jobs'
      fullPath: '/admin/employees/$id/jobs'
      preLoaderRoute: typeof AdminEmployeesIdJobsRouteImport
      parentRoute: typeof AdminEmployeesIdRoute
    }
    '/admin/employees/$id/goals': {
      id: '/admin/employees/$id/goals'
      path: '/goals'
      fullPath: '/admin/employees/$id/goals'
      preLoaderRoute: typeof AdminEmployeesIdGoalsRouteImport
      parentRoute: typeof AdminEmployeesIdRoute
    }
    '/admin/employees/$id/feedback': {
      id: '/admin/employees/$id/feedback'
      path: '/feedback'
      fullPath: '/admin/employees/$id/feedback'
      preLoaderRoute: typeof AdminEmployeesIdFeedbackRouteImport
      parentRoute: typeof AdminEmployeesIdRoute
    }
  }
}

interface AdminEmployeesIdRouteChildren {
  AdminEmployeesIdFeedbackRoute: typeof AdminEmployeesIdFeedbackRoute
  AdminEmployeesIdGoalsRoute: typeof AdminEmployeesIdGoalsRoute
  AdminEmployeesIdJobsRoute: typeof AdminEmployeesIdJobsRoute
  AdminEmployeesIdIndexRoute: typeof AdminEmployeesIdIndexRoute
}

const AdminEmployeesIdRouteChildren: AdminEmployeesIdRouteChildren = {
  AdminEmployeesIdFeedbackRoute: AdminEmployeesIdFeedbackRoute,
  AdminEmployeesIdGoalsRoute: AdminEmployeesIdGoalsRoute,
  AdminEmployeesIdJobsRoute: AdminEmployeesIdJobsRoute,
  AdminEmployeesIdIndexRoute: AdminEmployeesIdIndexRoute,
}

const AdminEmployeesIdRouteWithChildren =
  AdminEmployeesIdRoute._addFileChildren(AdminEmployeesIdRouteChildren)

interface AdminJobsIdRouteChildren {
  AdminJobsIdAssignedCustomersRoute: typeof AdminJobsIdAssignedCustomersRoute
  AdminJobsIdCandidatesRoute: typeof AdminJobsIdCandidatesRoute
  AdminJobsIdDetailsRoute: typeof AdminJobsIdDetailsRoute
  AdminJobsIdDuplicatesRoute: typeof AdminJobsIdDuplicatesRoute
  AdminJobsIdEditRoute: typeof AdminJobsIdEditRoute
  AdminJobsIdQualityRoute: typeof AdminJobsIdQualityRoute
  AdminJobsIdScrapingRoute: typeof AdminJobsIdScrapingRoute
  AdminJobsIdIndexRoute: typeof AdminJobsIdIndexRoute
}

const AdminJobsIdRouteChildren: AdminJobsIdRouteChildren = {
  AdminJobsIdAssignedCustomersRoute: AdminJobsIdAssignedCustomersRoute,
  AdminJobsIdCandidatesRoute: AdminJobsIdCandidatesRoute,
  AdminJobsIdDetailsRoute: AdminJobsIdDetailsRoute,
  AdminJobsIdDuplicatesRoute: AdminJobsIdDuplicatesRoute,
  AdminJobsIdEditRoute: AdminJobsIdEditRoute,
  AdminJobsIdQualityRoute: AdminJobsIdQualityRoute,
  AdminJobsIdScrapingRoute: AdminJobsIdScrapingRoute,
  AdminJobsIdIndexRoute: AdminJobsIdIndexRoute,
}

const AdminJobsIdRouteWithChildren = AdminJobsIdRoute._addFileChildren(
  AdminJobsIdRouteChildren,
)

interface AdminRouteChildren {
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminPerformanceRoute: typeof AdminPerformanceRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminCustomersIdRoute: typeof AdminCustomersIdRoute
  AdminCustomersNewRoute: typeof AdminCustomersNewRoute
  AdminCustomersRecommendationsRoute: typeof AdminCustomersRecommendationsRoute
  AdminEmployeesIdRoute: typeof AdminEmployeesIdRouteWithChildren
  AdminJobsIdRoute: typeof AdminJobsIdRouteWithChildren
  AdminJobsBulkUploadRoute: typeof AdminJobsBulkUploadRoute
  AdminJobsDuplicatesRoute: typeof AdminJobsDuplicatesRoute
  AdminJobsNewRoute: typeof AdminJobsNewRoute
  AdminJobsScrapingQueueRoute: typeof AdminJobsScrapingQueueRoute
  AdminScoutPostingsRoute: typeof AdminScoutPostingsRoute
  AdminScoutProgramsRoute: typeof AdminScoutProgramsRoute
  AdminScoutRunsRoute: typeof AdminScoutRunsRoute
  AdminScoutTargetsRoute: typeof AdminScoutTargetsRoute
  AdminSupportTicketIdRoute: typeof AdminSupportTicketIdRoute
  AdminCustomersIndexRoute: typeof AdminCustomersIndexRoute
  AdminEmployeesIndexRoute: typeof AdminEmployeesIndexRoute
  AdminJobsIndexRoute: typeof AdminJobsIndexRoute
  AdminPlansIndexRoute: typeof AdminPlansIndexRoute
  AdminSupportIndexRoute: typeof AdminSupportIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminPerformanceRoute: AdminPerformanceRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminCustomersIdRoute: AdminCustomersIdRoute,
  AdminCustomersNewRoute: AdminCustomersNewRoute,
  AdminCustomersRecommendationsRoute: AdminCustomersRecommendationsRoute,
  AdminEmployeesIdRoute: AdminEmployeesIdRouteWithChildren,
  AdminJobsIdRoute: AdminJobsIdRouteWithChildren,
  AdminJobsBulkUploadRoute: AdminJobsBulkUploadRoute,
  AdminJobsDuplicatesRoute: AdminJobsDuplicatesRoute,
  AdminJobsNewRoute: AdminJobsNewRoute,
  AdminJobsScrapingQueueRoute: AdminJobsScrapingQueueRoute,
  AdminScoutPostingsRoute: AdminScoutPostingsRoute,
  AdminScoutProgramsRoute: AdminScoutProgramsRoute,
  AdminScoutRunsRoute: AdminScoutRunsRoute,
  AdminScoutTargetsRoute: AdminScoutTargetsRoute,
  AdminSupportTicketIdRoute: AdminSupportTicketIdRoute,
  AdminCustomersIndexRoute: AdminCustomersIndexRoute,
  AdminEmployeesIndexRoute: AdminEmployeesIndexRoute,
  AdminJobsIndexRoute: AdminJobsIndexRoute,
  AdminPlansIndexRoute: AdminPlansIndexRoute,
  AdminSupportIndexRoute: AdminSupportIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
